export default __webpack_public_path__ + "static/media/WAS0333.34I-41671_-24943_0.3da9df09.jpg";